
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { gtmPageView } from "./gtmHelper";

export default function GTMRouteListener() {
  const location = useLocation();

  useEffect(() => {
    gtmPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
